module.exports = __webpack_public_path__ + "img/emoji_92.6b7eb9bf.png";